/**
 * Phase 18 close-off — Module 7 helper extraction.
 *
 * Pure helpers lifted out of WorkbenchEngagementPane.jsx so they can
 * be unit-tested without rendering the pane (which pulls in the API
 * client, react-router, and many sub-components). Mirrors the pattern
 * used for cmdPaletteRecents / heatmapResolution / isPickable.
 *
 *   • paramValue(p, def)       — scenario-resolution: read a value
 *     from a param that may be a raw number OR a {value, ...} wrapper.
 *   • checkPkMonotonic(xs, ys) — form-validation rule for the Pk-curve
 *     editor: miss_distance must ascend strictly; Pk must not increase.
 */

export function paramValue(p, def = null) {
    if (p == null) return def;
    if (typeof p === "number") return p;
    if (typeof p === "object" && p !== null && "value" in p) return p.value;
    return def;
}

export function checkPkMonotonic(xs, ys) {
    if (!Array.isArray(xs) || !Array.isArray(ys) || xs.length !== ys.length) {
        return "length mismatch";
    }
    if (xs.length < 2) return "need at least 2 points";
    for (let i = 1; i < xs.length; i += 1) {
        if (!(xs[i] > xs[i - 1])) {
            return `miss_distance must ascend strictly (pt ${i}: ${xs[i - 1]} → ${xs[i]})`;
        }
        if (ys[i] > ys[i - 1] + 1e-9) {
            return `pk must not increase (pt ${i}: ${ys[i - 1]} → ${ys[i]})`;
        }
    }
    return null;
}
